import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=4d1cd400"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d1cd400')) {
      api.createRecord('4d1cd400', component.options)
    } else {
      api.reload('4d1cd400', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=4d1cd400", function () {
      api.rerender('4d1cd400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ritualCircles/Editor.vue"
export default component.exports